import {
  Box,
  Heading,
  SimpleGrid,
  Text,
  useColorModeValue as mode,
  Flex,
  useDisclosure,
  HStack,
  Link,
  Input, Icon,
} from "@chakra-ui/react";
import * as React from "react";
import { Button } from "@chakra-ui/button";
import { loadStripe, StripeCardElement } from "@stripe/stripe-js";
import {
  CardElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { postData, roundUp } from "../../utils/helpers";
import { FiUnlock } from "react-icons/fi";
import { BsArrowReturnLeft } from "react-icons/bs";
import { FaFileInvoice, FaRocket } from "react-icons/fa";
import { firebaseClient } from "../../firebaseClient";
import { useSession } from "next-auth/react";
import toast from "react-hot-toast";
import router from "next/router";
import { ConfirmPopup } from "components/popups/confirmPopup";
import * as analytics from "../../utils/analytics";
import NextLink from "next/link"
import { resumeSubscription } from "controllers/subscription";
import { useFirebaseUser } from "utils/useFirebaseUser";
import { getAccount, updateUser, getAuthUrl } from "utils/sessionHelper";
import { textStyle, variant } from "theme/names";
import { CustomSection } from "components/custom-section";
import { getPeriodicity } from "../../controllers/subscription";

export const SubscriptionManagement = (props) => {
  const { data: session } = useSession() ?? {}
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoadingCancel, setIsLoadingCancel] = React.useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenSwitchAnnual, onOpen: onOpenSwitchAnnual, onClose: onCloseSwitchAnnual } = useDisclosure();
  const [email, setEmail] = React.useState("");
  const [isLoadingInvoice, setIsLoadingInvoice] = React.useState(false);
  const isAuthenticated = useFirebaseUser();

  const [cancelTitle, setCancelTitle] = React.useState("Before you go");
  const [cancelBody, setCancelBody] = React.useState("Is price an issue? Pay 20% less by switching to a yearly plan.");
  const [cancelCallback, setCancelCallback] = React.useState<any>("goToPricing");
  const [cancelCta, setCancelCta] = React.useState<any>("Check it out");

  React.useEffect(() => {
    if (isAuthenticated) {
      setEmail(getAccount(session).emailInvoice ?? "");
    }
  }, [isAuthenticated]);

  const redirect = async (event) => {

    let customer = session?.user?.data?.subscription?.customer;
    // console.log(customer);

    setIsLoading(true);

    if (!customer) {
      var db = firebaseClient.firestore();
      var userDoc = await db.collection("users").doc(session?.user.uid).get();
      let userData = userDoc.data();
      customer = userData?.subscription?.customer;
    }

    if (!customer) {
      setIsLoading(false);
      console.log("Error with the session object", session);
      toast.error("An error occurred, contact support at team@taplio.com", { style: { background: "gray.600", color: "#222" } });
      return;
    }

    let data = {
      // isLocal: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
      customer: customer,
      //@ts-ignore
      userId: session.user.uid, // @dimitri: fix this plz
    };

    // let stripeSession = await postData({
    //   url: "payment-createSessionSubscriptionManagement",
    //   token: "",
    //   data: data,
    // });

    const res = await fetch("/api/subscriptionManagement", {
      method: "POST",
      headers: new Headers({ "Content-Type": "application/json", token: "" }),
      credentials: "same-origin",
      body: JSON.stringify(data),
    });

    let stripeSession = await res.json();

    // console.log({ session: stripeSession });

    if (stripeSession && stripeSession.success) {
      window.location.href = stripeSession.url;
    } else {
      setIsLoading(false);
      console.log("An error happened during checkout. Please contact us for more information");
      toast.error("An error occurred, contact support at team@taplio.com", { style: { background: "gray.600", color: "#222" } });
    }
  };

  const cancelSubscription = async (event) => {

    setIsLoading(true);

    

    let dataToSend = {
      isLocal: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
      customer: session?.user?.data?.stripeId,
      subscription: session?.user?.data?.subscription?.subscription,
      userId: session?.user?.uid,
    };

    const res = await fetch("/api/subscriptionManagement", {
      method: "POST",
      headers: new Headers({ "Content-Type": "application/json", token: "" }),
      credentials: "same-origin",
      body: JSON.stringify(dataToSend),
    });

    let data = await res.json();

    if (data?.success) {
      toast.success("Your subscription has been cancelled");
    } else {
      setIsLoading(false);
      console.log("An error happened during checkout. Please contact us for more information");
      toast.error("An error occurred, contact support at team@taplio.com");
    }

  };

  const launchCancelFlow = async () => {
    setIsLoadingCancel(true);
    let response = await fetch(
      "/api/subscriptionInitChurnkey?stripeId=" +
      session?.user?.data?.stripeId
    );
    let json = await response.json();

    //@ts-ignore
    if (json?.success && json.hash && window?.churnkey?.init) {
      let hash = json.hash;
      //@ts-ignore
      window.churnkey.init("show", {
        customerId: session?.user?.data?.stripeId,
        authHash: hash,
        appId: "hj3t6nz4n",
        mode: "live",
        provider: "stripe",
      });
    } else
      toast.error(
        "An error occurred, contact support at team@taplio.com"
      );

    setIsLoadingCancel(false);
  }

  const showCancelButton = () => {
    return (
      <Button
        mt={5}
        variant="ghost"
        justifyContent="flex-start"
        isLoading={isLoadingCancel}
        onClick={async () => {
          
          // onOpen();

          if (getPeriodicity(session?.user) === "yearly") {
            launchCancelFlow();
          }
          else if (session?.user?.data?.subStatus?.includes("FreeTrial")) {
            setCancelTitle("You will lose access now");
            setCancelBody("If you cancel during free trial, you will lose access immediately. Do you want to continue?");
            setCancelCallback("close");
            setCancelCta("Close");
            onOpenSwitchAnnual();
          }
          else {
            //@ts-ignore
            if (["price_1MZWG7KB4y5X3SShRvzrSXN6", "price_1MTk3IKB4y5X3SShQR3FTtMH"].includes(session?.user?.data?.subscription?.plan)) {
              setCancelBody("Maybe the recent price increase bothers you and we understand that. Did you know you can pay even less than before by switching to a yearly plan?");
            }
            onOpenSwitchAnnual();
          }
        }}
      >
        Cancel subscription
      </Button>
    )
  }

  return (
    <CustomSection
      title="Email to send invoices"
      description="All invoices will be send to the email address specified bellow"
      css={{ maxW: "600px" }}
    >
      <Flex flexDir="column" w="250px" pb={10}>
        {/* <Text textStyle={textStyle["body.medium.light"]} mt={0}>Email to send invoices</Text> */}
        <Flex mt={2}>
          <Input
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            // maxW={300}
            w="sm"
            placeholder="invoices@mystartup.com"
          />
          <Button
            ml={2}
            isLoading={isLoadingInvoice}
            onClick={async () => {
              setIsLoadingInvoice(true);
              await updateUser(session, { emailInvoice: email }, true);
              setIsLoadingInvoice(false);
            }}
            // bg="blue.100"
            // _hover={{ bg: "blue.200" }}
            // color="gray.800"
            variant="primary"
          >
            Save
          </Button>
        </Flex>

        {/* <Box>
        <Button
          mt={10}
          leftIcon={<FaRocket />}
          colorScheme="twitter"
          fontWeight="bold"
          onClick={() => router.push("/pricing")}
          justifyContent="flex-start"
        >
          {session?.user?.data?.subscription?.isSubscribed ? "Update your plan" : "Subscribe"}
        </Button>
      </Box> */}
        <Box>
          <Button
            mt={10}
            leftIcon={<FaRocket />}
            variant={variant.Button.primary}
            // colorScheme="twitter"
            // fontWeight="bold"
            onClick={() => router.push("/pricing")}
          // justifyContent="flex-start"
          >
            {session?.user?.data?.subscription?.isSubscribed
              ? "Update your plan"
              : "Subscribe"}
          </Button>
        </Box>
        <Box mt={5}>
          <Button
            isLoading={isLoading}
            leftIcon={<Icon viewBox="0 0 12 17"> <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.25 5C8.65625 5 9 5.34375 9 5.75C9 6.1875 8.65625 6.5 8.25 6.5H3.75C3.3125 6.5 3 6.1875 3 5.75C3 5.34375 3.3125 5 3.75 5H8.25ZM8.25 10.5C8.65625 10.5 9 10.8438 9 11.25C9 11.6875 8.65625 12 8.25 12H3.75C3.3125 12 3 11.6875 3 11.25C3 10.8438 3.3125 10.5 3.75 10.5H8.25ZM3 8.5C3 8.09375 3.3125 7.75 3.75 7.75H8.25C8.65625 7.75 9 8.09375 9 8.5C9 8.9375 8.65625 9.25 8.25 9.25H3.75C3.3125 9.25 3 8.9375 3 8.5ZM2.5 1.78125L3.75 0.6875C4.03125 0.46875 4.4375 0.46875 4.71875 0.6875L6 1.78125L7.25 0.6875C7.53125 0.46875 7.9375 0.46875 8.21875 0.6875L9.5 1.78125L10.75 0.6875C10.9688 0.5 11.2812 0.46875 11.5625 0.59375C11.8125 0.71875 12 0.96875 12 1.25V15.75C12 16.0625 11.8125 16.3125 11.5625 16.4375C11.2812 16.5625 10.9688 16.5312 10.75 16.3438L9.5 15.25L8.21875 16.3438C7.9375 16.5625 7.53125 16.5625 7.25 16.3438L6 15.25L4.71875 16.3438C4.4375 16.5625 4.03125 16.5625 3.75 16.3438L2.5 15.25L1.21875 16.3438C1 16.5312 0.6875 16.5625 0.40625 16.4375C0.15625 16.3125 0 16.0625 0 15.75V1.25C0 0.96875 0.15625 0.71875 0.40625 0.59375C0.6875 0.46875 1 0.5 1.21875 0.6875L2.5 1.78125ZM2 13.6875C2.28125 13.4688 2.6875 13.4688 2.96875 13.6875L4.25 14.7812L5.5 13.6875C5.78125 13.4688 6.1875 13.4688 6.46875 13.6875L7.75 14.7812L9 13.6875C9.28125 13.4688 9.6875 13.4688 9.96875 13.6875L10.5 14.125V2.90625L9.96875 3.34375C9.6875 3.5625 9.28125 3.5625 9 3.34375L7.75 2.25L6.46875 3.34375C6.1875 3.5625 5.78125 3.5625 5.5 3.34375L4.25 2.25L2.96875 3.34375C2.6875 3.5625 2.28125 3.5625 2 3.34375L1.5 2.90625V14.125L2 13.6875Z" fill="#0A66C2" />
            </svg>
            </Icon>}
            // fontWeight="bold"
            onClick={redirect}
            justifyContent="flex-start"
            variant="secondary"
          >
            Invoices & subscription
          </Button>
        </Box>
        {session?.user?.data?.subscription?.isPaused ? (
          <Flex flexDirection="column">
            <Box mt={10} w="250px">
              <Text textStyle={textStyle["body.medium.light"]}>Your subscription is paused</Text>
              <Button
                mt={2}
                variant={variant.Button.primary}
                // colorScheme="twitter"
                // fontWeight="bold"
                onClick={() => {
                  resumeSubscription(session, setIsLoading);
                }}
              >
                Resume subscription
              </Button>
            </Box>
            <Box>
              {showCancelButton()}
            </Box>
          </Flex>
        ) : session?.user?.data?.subscription?.isSubscribed &&
          session.user.data.subStatus?.includes("_CancelRequest") ? (
          <Box mt={10} w="300px">
            <Text textStyle={textStyle["body.medium.light"]}>
              Your subscription will be canceled at the end of the billing period
            </Text>
            <Button
              mt={2}
              leftIcon={<FaRocket />}
              variant={variant.Button.primary}
              // colorScheme="twitter"
              fontWeight="bold"
              onClick={() => {
                resumeSubscription(session, setIsLoading);
              }}
            >
              Reactivate your subscription
            </Button>
            {/* {
                isElligibleRefund && (
                  <Button
                    mt={5}
                    leftIcon={<BsArrowReturnLeft />}
                    onClick={() => {
                      
                      onOpenRefund();
                    }}
                  >
                    Ask for a refund
                  </Button>
                )
              } */}
          </Box>
        ) : (
          session?.user?.data?.subscription?.isSubscribed && (
            <Box>
              {showCancelButton()}
            </Box>
          )
        )}

        <ConfirmPopup
          isOpen={isOpen}
          onClose={onClose}
          title={`You are about to lose ${roundUp(getAccount(session)?.thTokens) || "your"
            } TH tokens.`}
          allowClickBackground={true}
          body={
            <Box>
              <Text textStyle={textStyle["body.medium.light"]} fontSize="sm">
                Every day you use Tweet Hunter, you accumulate tokens that will
                get you a piece of the pie if Tweet Hunter is ever sold to another
                company.
                <Link as={NextLink} href="/tokens" ml="1" color="blue.400">
                  learn more
                </Link>
                <br />
                <br />
                <b>
                  You won’t be able to recover those tokens if you come back
                  later.
                </b>
              </Text>
              <Text textStyle={textStyle["body.medium.light"]} textAlign="center" fontWeight="bold" mt="6">
                Are you sure you want to move forward?
              </Text>
            </Box>
          }
          // @ts-ignore
          customFooter={
            <HStack justifyContent="center" w="100%" mt="1" mb="6" spacing="3">
              <Button
                variant="ghost"
                borderRadius="xl"
                onClick={() => {
                  onClose();
                }}
              >
                Yes, I want to lose my tokens
              </Button>
              <Button colorScheme="blue" borderRadius="xl" onClick={onClose}>
                Go back
              </Button>
            </HStack>
          }
          callback={() => { }}
        />
        <ConfirmPopup
          isOpen={isOpenSwitchAnnual}
          onClose={onCloseSwitchAnnual}
          title={cancelTitle}
          allowClickBackground={true}
          body={cancelBody}
          cta={cancelCta}
          // callback={launchCancelFlow}
          callback={() => {
            if (cancelCallback === "close")
              onCloseSwitchAnnual();
            else
              router.push("/pricing")
          }}
          customAlternateAction={({ callback }) => (
            <Button
              variant="tertiary"
              onClick={() => {
                onCloseSwitchAnnual();
                launchCancelFlow();
              }}>
              Cancel & delete my account
            </Button>
          )}
        />
      </Flex>
    </CustomSection>
  );

};

export default SubscriptionManagement;
